import React, { useState} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from '../../redux/actions/';
import { FaTimes } from 'react-icons/fa';
import './notifications.scss'

export const Notifications = ({notifications, addNotification, deleteNotification}) => {
	const [fadeOut, setFadeOut] = useState(false);

	const handleDelete = (notification) => {
		deleteNotification(notification);
	}

	const forceDelete = (notification) => {
		setFadeOut(true);
		setTimeout(() => {
			handleDelete(notification);
			setFadeOut(false);
		}, 4000);
	}

	const renderNotifications = () => {
		let notificationNodes = [];
		notifications.forEach((notification, index) => {
			notificationNodes.push(
				<div key={notification.id} className={`notification notification-${notification.type || 'success'}`}>
					<div className="notification-message">{notification.message}</div>
					<div className="notification-close">
						<button onClick={() => {handleDelete(notification)}}><FaTimes /></button>
					</div>
				</div>
			);
			if (notification.type !== 'error') {
				setTimeout(() => {
					forceDelete(notification);
				}, 4000);
			}
		});

		return notificationNodes.length ? (<div className={`notifications-wrap ${fadeOut ? 'fade-out' : ''}`}>
			{notificationNodes}
		</div>) : null;
	};


	return renderNotifications();
};

Notifications.propTypes = {
	notifications: PropTypes.array,
	addNotification: PropTypes.func,
	deleteNotification: PropTypes.func
};

const mapStateToProps = state => {
  return {notifications: state.notifications.map((notification, index) => ({...notification, ...{id: `notification_${index}`}}))};
};

const mapDispatchToProps  = {
	addNotification: Actions.addNotification,
	deleteNotification: Actions.deleteNotification
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
